// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass } from "./Dom";
import { WebPageComponent } from "./WebSite.Page.Component";

export class Collapsible extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    this.toggleElement.onclick = (event) => { this.toggle(event); };
  }

  determineElements() {
    this.collapsed = new HtmlClassSwitch(this.element, "Collapsed");

    const query = new DomQuery(this.element);
    const toggle = query.getDescendant(WithClass("Toggle"));

    this.toggleElement = toggle !== null ? toggle : this.element;
    this.toggleElement.tabIndex = 0;
  }

  toggle(event) {
    if (event.target.href === undefined) {
      this.collapsed.toggle();
      this.toggleElement.setAttribute('aria-expanded', !this.collapsed.getStatus());
    }
  }
}

interactivityRegistration.register("Collapsible", function (element) { return new Collapsible(element); });
